import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasDailyLoop } from '../services/daily-loop';
import { SessionService } from '../services/session.service';

/**
 * Surface split (Danna 25.09, part B3): the daily loop lives in the app. On
 * the WEB, home, the tools catalogue, a single tool and the daily check-in are
 * not rendered; an old link or bookmark lands on her latest results instead
 * (or on a new scan when she has none). Never a 404, never an empty shell.
 * Native, and Peritale web (no app yet), keep every one of these routes.
 * Runs after authGuard, so a signed-out visitor is still sent to login.
 */
export const webDailyLoopGuard: CanActivateFn = async (_route, state) => {
  if (hasDailyLoop()) return true;
  const session = inject(SessionService);
  const router = inject(Router);
  const lang = state.url.match(/^\/(en|he)(?:\/|$)/)?.[1] || 'en';
  const userId = session.session?.user?.id;
  // No session: authGuard (earlier in the list) owns the redirect.
  if (!userId) return true;
  const guid = await session.getLatestCompletedScanGuid(userId);
  return guid
    ? router.createUrlTree([lang, 'app', 'results', guid])
    : router.createUrlTree([lang, 'app', 'new-test']);
};
